var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"reveal-field",on:{"click":_vm.toggle}},[_c('b-icon',{attrs:{"icon":_vm.icon,"size":"is-small"}}),_c('span',[_vm._v(_vm._s(_vm.label))]),_c('input',{ref:"input"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f5fba87","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RevealField.vue
// module id = Ag/x
// module chunks = 1